import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import CityPage from './pages/CityPage';
import ArticleIndex from './pages/ArticleIndex';
import ArticlePage from './pages/ArticlePage';
import ResourcePage from './pages/ResourcePage';
import OrgPage from './pages/OrgPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/cities/:slug" element={<CityPage />} />
        <Route path="/cities/:citySlug/council" element={<ArticleIndex />} />
        <Route path="/cities/:citySlug/council/:slug" element={<ArticlePage />} />
        <Route path="/cities/:citySlug/resources" element={<ResourcePage />} />
        <Route path="/cities/:citySlug/org/:slug" element={<OrgPage />} />
      </Routes>
    </BrowserRouter>
  );
}
